var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.035.172a.677.677 0 0 0-.902 0 .56.56 0 0 0 0 .834l3.687 3.405H.639l-.129.011C.22 4.477 0 4.716 0 5c0 .326.286.59.639.59H15.82l-3.688 3.405a.56.56 0 0 0 0 .833c.249.23.653.23.902 0l4.778-4.41a.56.56 0 0 0 0-.835z"
  })));
};
export default SvgArrowRight;